import { formatMoney, formatMoneyFull } from "../../../../utils/formatters";

export const available = (value) => value !== null && value !== undefined && value !== "";
export const money = (value, currency, full = false) => available(value)
  ? (full ? formatMoneyFull(value, currency) : formatMoney(value, currency))
  : "Not available";

export function Section({ title, stage, children }) {
  return <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
    {stage && <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-800">{stage}</p>}
    <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-4">{children}</div>
  </section>;
}

export function Kpi({ label, value, detail }) {
  return <div className="rounded-xl border border-slate-100 bg-slate-50/70 p-4">
    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
    <p className="mt-2 text-lg font-semibold text-slate-900">{value}</p>
    {detail && <p className="mt-1 text-xs leading-5 text-slate-500">{detail}</p>}
  </div>;
}
